export var InterviewManifestRoutes = {
    "/interview-schedule?job_id&brand_id&date&interviewer_id": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.manifest",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview_manifest"]
        },

        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Schedule"
            }
        ],
        "component": "interviewManifestPage",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-scheduling.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/talent-pool/talent-pool.module.js");
                }
            },
        ],
        "onEnter": ['$state', 'brandServices', 'hUser', function ($state, brandServices, hUser) {
            brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, hUser.getUserContext().brand_id)
                .then(function (isOnBoardingJourneyEnabled) {
                    if (isOnBoardingJourneyEnabled) {
                        if(hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        } else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                })
                .catch(function (err) {
                    console.error(err);
                });
        }],
    }
};